// Libs
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Emoji } from "shared_components";
import { browserHistory } from "react-router";

// Actions
import { setPersonalization } from "../../module/store/personalization";
import { closeModal } from "../../../actions/ui";

// Components
import ModalWrapper from "../../../components/_Shared/ModalWrapper";
import { Button, Dropdown } from "../../spocketUI";
import { default as Loadable } from "../../../components/_Shared/commonLoadable";

// Images
import banner from "../../images/set-goals-banner.jpg";

// i18n
import { useTranslation } from "react-i18next";

import {
  Icon,
  Title,
  Header,
  Footer,
  Select,
  Section,
  Subtitle,
  SelectInfo,
  Description,
  SelectValue
} from "./SetYourGoalsModalStyle";

import "./SetYourGoalsModal.css";

const starter = [1, 5, 10, 25];
const pro = [1, 5, 10, 25, 50, 100, 250];
const empire = [1, 5, 10, 25, 50, 100, 250, 500];
const unicorn = [1, 5, 10, 25, 50, 100, 250, 500];

const SetYourGoalsModal = ({
  abTests,
  closeModal,
  isFetching,
  currentPlan,
  setPersonalization
}) => {
  const [numberOfProducts, setNumberOfProducts] = useState();
  const { t } = useTranslation();

  useEffect(
    () => {
      const plan = currentPlan.name;

      plan === "Starter" && setNumberOfProducts(25);
      plan === "Professional" && setNumberOfProducts(50);
      plan === "Empire" && setNumberOfProducts(500);
      plan === "Unicorn" && setNumberOfProducts(500);
    },
    [currentPlan.name]
  );

  const getNumberOfProducts = () => {
    const plan = currentPlan.name;
    if (plan === "Starter") {
      return starter;
    } else if (plan === "Professional") {
      return pro;
    } else if (plan === "Empire") {
      return empire;
    } else if (plan === "Unicorn") {
      return unicorn;
    } else {
      return [""];
    }
  };

  // I could do it dinamically but I dont wanna interpolattion on
  // i18n keys, let's make it easy to find them all
  const getPlanLabel = () => {
    switch (currentPlan.name) {
      case "Starter": return t("Plan.Starter");
      case "Professional": return t("Plan.Professional");
      case "Empire": return t("Plan.Empire");
      case "Unicorn": return t("Plan.Unicorn");
      default: return "";
    }
  };

  const isPremiumProductBlurAbTest = () => {
    const premiumProductBlur = abTests.find(
      abTest => abTest.name === "Premium Product Blur"
    );

    return premiumProductBlur !== undefined ? premiumProductBlur.test : false;
  };

  const redirectUser = () => {
    if (
      window.location.pathname === "/search" &&
      isPremiumProductBlurAbTest()
    ) {
      window.location.reload();
    } else {
      browserHistory.push("/search");
    }
  };

  return (
    <ModalWrapper
      className="SetYourGoalsModal__container"
      backdropClassName="SetYourGoalsModal__backdrop"
      onHide={async () => {
        await setPersonalization({
          goals: { number_of_products: numberOfProducts }
        });
        await closeModal();
        redirectUser();
      }}
    >
      <Loadable active={isFetching}>
        <Header>
          <img src={banner} alt="banner" />
        </Header>
        <ModalWrapper.Body>
          <Section>
            <Description>
              <Icon>
                <Emoji label="Shopping bag" symbol="🛍️" />
              </Icon>
              <Title>
                { t("SetYourGoalsModal.Title") }
                <Subtitle>
                  { t("SetYourGoalsModal.Subtitle") }
                </Subtitle>
              </Title>
            </Description>
            <Dropdown>
              <Dropdown.Trigger>
                <Select>
                  <SelectValue>{numberOfProducts}</SelectValue>
                  <SelectInfo>{getPlanLabel()}</SelectInfo>
                </Select>
              </Dropdown.Trigger>
              <Dropdown.Content>
                {getNumberOfProducts().map(amount => {
                  return (
                    <Dropdown.Item
                      checked={numberOfProducts === amount}
                      onClick={() => setNumberOfProducts(amount)}
                    >
                      { t("SetYourGoalsModal.DropdownItem.Product", { count: amount })}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Content>
            </Dropdown>
          </Section>
          <Footer>
            <Button
              variant="primaryBig"
              onClick={async () => {
                await setPersonalization({
                  goals: { number_of_products: numberOfProducts }
                });
                await closeModal();
                redirectUser();
              }}
            >
              { t("SetYourGoalsModal.Button") }
            </Button>
          </Footer>
        </ModalWrapper.Body>
      </Loadable>
    </ModalWrapper>
  );
};

function mapStateToProps(state) {
  return {
    isFetching: state.store.personalization.isFetching,
    currentPlan: state.settings.currentPlan,
    abTests: state.settings.dropshipperData.ab_tests
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      closeModal,
      setPersonalization
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetYourGoalsModal);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/modalConductor/SetYourGoalsModal.js